import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FaCheck, FaWhatsapp, FaEnvelopeOpenText } from "react-icons/fa";
import { FEATURED_PRODUCTS, COMPANY } from "../data/content";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const FeaturedProducts = ({ onEnquiry }) => (
    <section data-testid="featured-products-section" className="relative py-20 sm:py-28 bg-slate-50/70 dark:bg-slate-950/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center max-w-2xl mx-auto mb-12"
            >
                <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 dark:text-brand-300 mb-4">Featured Products</div>
                <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white">
                    Best-in-Class <span className="text-gradient-brand">Equipment</span>
                </h2>
                <p className="mt-4 text-slate-600 dark:text-slate-300">Hand-picked premium products from trusted global brands.</p>
            </motion.div>

            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={24}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                autoplay={{ delay: 4500, disableOnInteraction: false }}
                breakpoints={{
                    640: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }}
                className="!pb-14"
            >
                {FEATURED_PRODUCTS.map((p, i) => (
                    <SwiperSlide key={p.name}>
                        <div data-testid={`product-card-${i}`} className="group h-full bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-slate-800 rounded-3xl overflow-hidden flex flex-col hover:shadow-2xl hover:shadow-brand-500/15 hover:-translate-y-1 transition-all">
                            <div className="aspect-[4/3] overflow-hidden bg-slate-100 dark:bg-slate-800">
                                <img src={p.img} alt={p.name} loading="lazy"
                                     className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                     onError={(e) => { e.currentTarget.src = "https://images.pexels.com/photos/263402/pexels-photo-263402.jpeg?w=900"; }} />
                            </div>
                            <div className="p-6 flex-1 flex flex-col">
                                <h3 className="font-heading font-bold text-lg text-slate-900 dark:text-white">{p.name}</h3>
                                <ul className="mt-3 space-y-1.5 text-sm text-slate-600 dark:text-slate-300 flex-1">
                                    {p.features.map((f) => (
                                        <li key={f} className="flex items-start gap-2">
                                            <FaCheck className="text-emerald-500 mt-0.5 flex-shrink-0" />
                                            <span>{f}</span>
                                        </li>
                                    ))}
                                </ul>
                                <div className="flex gap-2 mt-5">
                                    <button
                                        data-testid={`product-enquiry-btn-${i}`}
                                        onClick={() => onEnquiry?.(p.name)}
                                        className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-brand-700 hover:bg-brand-800 text-white text-sm font-semibold transition"
                                    >
                                        <FaEnvelopeOpenText /> Enquiry
                                    </button>
                                    <a
                                        href={`https://wa.me/${COMPANY.phoneDigits}?text=${encodeURIComponent("Enquiry: " + p.name)}`}
                                        target="_blank" rel="noopener noreferrer"
                                        data-testid={`product-whatsapp-btn-${i}`}
                                        className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-emerald-500 text-white hover:shadow-lg transition"
                                    >
                                        <FaWhatsapp />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    </section>
);

export default FeaturedProducts;
